import script from "./school_teacher_select.vue?vue&type=script&setup=true&lang=ts"
export * from "./school_teacher_select.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__